import axios from "../../axiosMiddleware";
import { api } from "../../apiendpoints";

export const manageFavoriteMenu = async ({
  menuPath = null,
  isFavorite = null,
} = {}) => {
  const response = await axios.post(
    api.ADMIN.FAVORITE,
    {
      menuPath,
      isFavorite,
    }
  );

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  return response?.data?.data || [];
};